import { registerPlugin } from '@capacitor/core';
const JustWeiWechat = registerPlugin('JustWeiWechat', {
    web: () => import('./web').then((m) => new m.JustWeiWechatWeb()),
});
export * from './definitions';
export { JustWeiWechat };
//# sourceMappingURL=index.js.map